import { Button, Grid, Slide } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

import { useHomeStore } from 'context/HomeStore'
import { AutoCompleteField } from 'asterX-UI/Inputs'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import { useSnackbar } from 'notistack'
import { CollectionService } from 'lib/api/services/collection.service'
import { useAuthStore } from 'context/AuthStore'
import { useStyles } from './update-list.styles'

export const UpdateList = ({ page }) => {
  const classes = useStyles({ page })
  const { enqueueSnackbar } = useSnackbar()
  const { homeStore, homeStoreFunc } = useHomeStore()
  const { authStore } = useAuthStore()
  const [assignTo, setAssignTo] = useState(null)
  const [openConfirm, setOpenConfirm] = useState(false)

  useEffect(() => {
    const parentElement = document.getElementById('root')

    if (parentElement) {
      if (homeStore?.selectedRows?.length) {
        parentElement.style.paddingBottom = authStore?.isMobile ? (page === 'tasks' ? '35vh' : '30vh') : '20vh'
      } else {
        parentElement.style.paddingBottom = ''
      }
    }

    return () => {
      const parentElementCleanup = document.getElementById('root')
      if (parentElementCleanup) {
        parentElementCleanup.style.paddingBottom = ''
      }
    }
  }, [homeStore?.selectedRows?.length, authStore?.isMobile])

  useEffect(() => {
    if (homeStore?.selectedRows?.length === 0) {
      setAssignTo(null)
    }
  }, [homeStore?.selectedRows?.length])

  const handleManagerChange = e => {
    const value = e.target.value
    setAssignTo(value)
  }

  const handleAssignTo = async () => {
    if (!assignTo) {
      enqueueSnackbar('Выберите менеджера', { variant: 'warning' })
      return
    }
    const manager = homeStore.managers.find(manager => manager?.username === assignTo)
    const data = {
      idList: homeStore.selectedRows,
      assignTo,
      assignToFullName: `${manager?.lastName} ${manager?.firstName}`
    }

    const res = await CollectionService.updateListAssignTo(data)

    if (res?.data) {
      enqueueSnackbar('Успешно 😸', { variant: 'success' })
      handleClearAssignTo()
      setOpenConfirm(false)
      window.location.reload()
    } else {
      enqueueSnackbar('Ошибка 😿', { variant: 'error' })
    }
  }

  const handleOpenConfirm = () => {
    if (!assignTo) {
      enqueueSnackbar('Выберите менеджера', { variant: 'warning' })
      return
    }
    setOpenConfirm(true)
  }

  const handleClearAssignTo = () => {
    setAssignTo(null)
    homeStoreFunc.setSelectedRows([])
    homeStoreFunc.setSelectAll(false)
  }

  return (
    <>
      <Slide direction="up" in={homeStore?.selectedRows?.length} mountOnEnter unmountOnExit>
        <Grid container spacing={4} className={classes.updateList}>
          <Grid item container className={classes.wrapper}>
            <Grid item container justifyContent={'space-between'} className={classes.counts}>
              <Grid item xs={12} md={4} lg={3}>
                {`Количество контрактов: ${homeStore?.selectedRows?.length}`}
              </Grid>
              {page === 'tasks' && (
                <>
                  <Grid item xs={6} md={4} lg={2}>
                    {`Soft: ${homeStore?.counts?.SOFT}`}
                  </Grid>
                  <Grid item xs={6} md={4} lg={2}>
                    {`Hard: ${homeStore?.counts?.HARD}`}
                  </Grid>
                  <Grid item xs={6} md={4} lg={2}>
                    {`Legal: ${homeStore?.counts?.LEGAL}`}
                  </Grid>
                  <Grid item xs={6} md={4} lg={2}>
                    {`Offbalance: ${homeStore?.counts?.OFFBALANCE}`}
                  </Grid>
                </>
              )}
            </Grid>
            <Grid item container justifyContent={'space-between'} spacing={4}>
              <Grid item xs={12} md={6} lg={6}>
                <AutoCompleteField
                  fullWidth
                  value={assignTo}
                  onChange={handleManagerChange}
                  options={homeStore.managers}
                  keyArr={'username'}
                  labelKeys={['firstName', 'lastName']}
                  valueKey={'username'}
                  name="assignTo"
                  placeholder="Менеджер"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6} className={classes.updateListBtn}>
                <Grid item xs={12} md={6}>
                  <Button fullWidth variant={'outlined'} onClick={handleClearAssignTo}>
                    {`Сбросить (закрыть)`}
                  </Button>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Button
                    fullWidth
                    variant={'contained'}
                    style={{ minWidth: 160 }}
                    color={'primary'}
                    onClick={handleOpenConfirm}
                  >
                    Назначить
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Slide>
      <ActionModal
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        onCancel={() => setOpenConfirm(false)}
        onConfirm={() => handleAssignTo()}
        title="Назначить контракты менеджеру"
      />
    </>
  )
}
